import { render, staticRenderFns } from "./book_form.vue?vue&type=template&id=4a8ec618&"
import script from "./book_form.vue?vue&type=script&lang=js&"
export * from "./book_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports